// Helper to get auth token
export const getAuthToken = () => {
  const token = localStorage.getItem('token');
  return token;
};

// Helper to get auth tokens
export const getAuthTokens = () => {
  const token = localStorage.getItem('token');
  const refreshToken = localStorage.getItem('refresh_token');
  return { token, refreshToken };
};

// Helper to check if token is likely to be valid
export const isTokenValid = () => {
  try {
    const token = localStorage.getItem('token');
    
    // If there's no token, it's not valid
    if (!token) {
      return false;
    }
    
    // Try to parse the token (assuming JWT format)
    // This is a simple check that doesn't verify the signature
    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
      return false;
    }
    
    // Check expiration
    try {
      const payload = JSON.parse(atob(tokenParts[1]));
      if (payload.exp) {
        // Token has expired
        if (payload.exp * 1000 < Date.now()) {
          localStorage.removeItem('token');
          localStorage.removeItem('refresh_token');
          return false;
        }
      }
    } catch (e) {
      // If we can't parse the token, assume it's invalid
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error checking token validity:', error);
    return false;
  }
};

// Helper to clear auth data when session expires
export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  sessionStorage.removeItem('redirectUrl');
}; 